import { ChatMessage } from './aiAssistantModel'

export type MessageDisplayState = {
  isStreaming: boolean
  showRating: boolean
  optionsInteractive: boolean
}

export function getMessageDisplayState(
  message: ChatMessage,
  isLast: boolean,
  chatIsStreaming: boolean
): MessageDisplayState {
  const isAssistant = message.role === 'assistant'
  const isStreaming = chatIsStreaming && isAssistant && isLast
  return {
    isStreaming,
    showRating: isAssistant && !isStreaming,
    // An option selector is only answerable on the most recent assistant
    // message while the chat is idle; older selectors render inert.
    optionsInteractive: isAssistant && isLast && !isStreaming,
  }
}
